module.exports = "<div class=\"content-layout-container\"> <!-- classes: with-head-bar -->\n            <jf-grid\n                    grid-options=\"SystemLic.gridOptions\"\n                    filter-field=\"name\"\n                    ng-if=\"SystemLic.gridOptions\"\n                    object-name=\"license\"\n                    auto-focus=\"true\">\n            </jf-grid>\n\n            <jf-table-view options=\"SystemLic.tableViewOptions\"></jf-table-view>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./modules/xray/states/settings/tabs/system_licenses/system_licenses.html
// module id = 691
// module chunks = 6